import FadeImage from './FadeImage';
import { originalImageUrl, resizedImageUrl } from '../utils/imageUrl';

/**
 * 파트너 로고.
 *
 * 리사이즈본은 손실 webp라 투명 배경이 사라진다 — 배경이 검정으로 깔려 로고가 깨져 보인다.
 * 그래서 투명이 살아 있는 원본을 먼저 시도하고, 없으면 리사이즈본으로 물러난다.
 * (근본 해결은 서버가 알파를 보존한 webp를 만드는 것)
 *
 * 원본 확장자는 URL에 남지 않아 png로 가정한다. 투명 로고는 사실상 png이고,
 * 아니면 medium → 서버가 준 URL 순으로 자연스럽게 내려간다.
 *
 * @param {string} src        서버가 준 로고 URL (원본일 수도, 리사이즈본일 수도 있다)
 * @param {string} alt
 * @param {string} background 로고 뒤에 깔 색
 */
export default function PartnerLogo({ src, alt, background }) {
  const original = originalImageUrl(src, 'png');
  const medium = resizedImageUrl(src, 'medium');

  return (
    <FadeImage
      // 원본(투명 유지) → medium(해상도 충분) → 서버가 준 것 순으로 물러난다
      src={original ?? src}
      originalUrl={medium ?? undefined}
      fallback={src}
      alt={alt}
      background={background}
      style={{ objectFit: 'contain' }}
    />
  );
}
